module.exports = __webpack_public_path__ + "static/media/imgTestDepoiments.1ca436d6.svg";